// CSS Modules - component class name prefix: CloudWordBox__

<template>
  <div :class="$style.container">
    <div :class="$style.head">{{ cloudOptions[0].title }}</div>
    <div :class="$style.tagContainer">
      <a
        v-for="(link, index) in cloudOptions[0].links"
        :class="[$style.tag, `weight-${link[1]}`]"
        :key="index"
        :href="link[2]"
        >{{ link[0] }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "CloudWordBox",
  props: {
    cloudOptions: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style module lang="scss">
@import "./CloudWordBox.scss";
</style>
